export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-16">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">投稿与合作</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
          <p className="mt-2 text-foreground-600 text-sm">欢迎投稿爆料或商务合作洽谈</p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100">
                <i className="ri-send-plane-line text-2xl text-primary-500"></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">投稿爆料</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                如果您掌握独家内幕线索或一手资讯，欢迎通过投稿通道发送给我们。编辑团队将严格审核并保护您的隐私安全。
              </p>
              <a
                href="mailto:tougao@heiliaowang.com"
                className="mt-3 inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                tougao@heiliaowang.com
                <i className="ri-arrow-right-up-line text-xs"></i>
              </a>
            </div>

            <div className="text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-accent-100">
                <i className="ri-briefcase-line text-2xl text-accent-500"></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">商务合作</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                广告投放、内容合作、品牌联动等商务需求，请通过邮箱联系我们，我们将在24小时内回复您的合作咨询。
              </p>
              <a
                href="mailto:hezuo@heiliaowang.com"
                className="mt-3 inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                hezuo@heiliaowang.com
                <i className="ri-arrow-right-up-line text-xs"></i>
              </a>
            </div>

            <div className="text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-secondary-100">
                <i className="ri-question-answer-line text-2xl text-secondary-500"></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">意见反馈</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                对黑料网站有任何意见、建议或问题反馈，欢迎随时联系我们，您的每一条反馈我们都认真对待。
              </p>
              <a
                href="mailto:fankui@heiliaowang.com"
                className="mt-3 inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                fankui@heiliaowang.com
                <i className="ri-arrow-right-up-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}